import { computed, ref } from 'vue';
import { useAbility } from '@casl/vue';
import { useAbilities } from '@/queries/auth/use-login';

const isOpen = ref(false);

const searchSubjects = [
  ['User', 'customers'],
  ['Booking', 'bookings'],
  ['Invoice', 'invoices'],
  ['Car', 'vehicles'],
] as const;

export function useCommandPalette() {
  const ability = useAbility();
  const { data: abilityRules } = useAbilities();

  const searchableLabels = computed(() => {
    if (!abilityRules.value?.length) return [];
    return searchSubjects.flatMap(([subject, label]) =>
      ability.can('list', subject) ? [label] : [],
    );
  });

  const canOpen = computed(
    () =>
      !!abilityRules.value?.length &&
      searchSubjects.some(([subject]) => ability.can('list', subject)),
  );

  function openCommandPalette() {
    if (!canOpen.value) return;
    isOpen.value = true;
  }

  function closeCommandPalette() {
    isOpen.value = false;
  }

  return { isOpen, canOpen, searchableLabels, openCommandPalette, closeCommandPalette };
}
